import { BaseController } from '~client/controller/base-controller';
import { UserNotificationSettingListResponse } from '~client/model/user-notification-setting-list-response';
import { UserNotificationSettingUpdateRequest } from '~client/model/user-notification-setting-update-request';

/* User APIs to view or update email/mobile push notification settings */
export class UserNotificationSettingsController extends BaseController {
  /* Allows the user to view their notification settings */
  public getNotificationSettings(): Promise<UserNotificationSettingListResponse> {
    return this.get('/user/notificationSettings/v2');
  }

  /* Allows the user to update their notification settings */
  public updateNotificationSettings(
    request: UserNotificationSettingUpdateRequest,
  ): Promise<UserNotificationSettingListResponse> {
    return this.put('/user/notificationSettings/v2', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/user-notification-settings-controller.ts